<div class="d-flex w-100 h-100 overflow-hidden">
      @if (!baseService.isMobile) {
        <div class="chat-menu">
          <div class="close-box">
            <app-button btnType="icon" (onChangeClick)="onClose()">
              <app-icon>close</app-icon>
            </app-button>
          </div>

          <mat-divider></mat-divider>

          <div class="box-items crm-scroll">
            @for (item of menuItems; track $index) {
              @if (!item.hidden) {
                <div class="menu-item w-100 click-css p-1"
                     (click)="onChangeTab(item.key)"
                     [ngClass]="{'active-menu': item.key === chatService.selectedTab.key }">
                  @if (item.is_mat_icon) {
                    <app-icon>{{ item.icon }}</app-icon>
                  } @else {
                    <img [src]="item.icon" alt="chat menu icon" class="menu-icon rounded-circle" />
                  }
                  <span>{{ 'chats_sidebar_menu.' + item.key | translate }}</span>
                </div>
              }
            }
          </div>
        </div>
      }

      @if (chatService.selectedTab && chatService.selectedTab.key) {
        @if (!baseService.isMobile || (!chatService.selectedChatId && baseService.isMobile)) {
          <div>
            <div id="leftMenu"
                 [ngClass]="{ 'mobile-width': baseService.isMobile, 'custom-width': !baseService.isMobile }"
                 class="left-menu-wrapper">
              <app-chat-list [ngClass]="{ 'd-none': chatService.leftMenu }"
                             [selectedTabKey]="chatService.selectedTab.key" />

              @if (chatService.leftMenu) {
                <div class="left-menu">
                  @switch (chatService.leftMenu) {
                    @case (LEFT_MENU.SETTINGS) {
                      <app-chat-settings />
                    }
                  }
                </div>
              }
            </div>
          </div>
        }

        @if (!baseService.isMobile || (chatService.selectedChatId && baseService.isMobile)) {
          <app-chat [chat]="chatService.chat"
                    class="w-100 overflow-hidden" />
        }

        @if (chatService.rightMenu) {
          <div class="right-menu"
               [ngClass]="{ 'right-menu-mobile': baseService.isMobile }">
            @switch (chatService.rightMenu) {
              @case (RIGHT_MENU.ABOUT) {
                <app-chat-about [chat]="chatService.chat" />
              }
            }
          </div>
        }
      }
    </div>
